// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6aed96e6","455":"5c245d0b","977":"489e423f"}[chunkId] + ".chunk.js";
};